/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { ListCompositionsQueryResponse, ListCompositionsQueryParams } from "../models/ListCompositions";

export function getListCompositionsUrl() {
  const res = { method: 'GET', url: `/compositions` as const }
  return res
}

/**
 * @summary List compositions for a station (creator, edit previews; optional start/end on createdAt; optional name LIKE filter)
 * {@link /compositions}
 */
export async function listCompositions(params: ListCompositionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListCompositionsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getListCompositionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}